module.exports = __webpack_public_path__ + "static/call-us-bg-ba4aef63c5ff337999a4ae4748268329.svg";